import { Download, Save } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function DownloadSidebar() {
  return (
    <div className="space-y-6 rounded-lg border border-gray-200 p-4">
      <div>
        <h3 className="font-medium">Download Options</h3>
        <div className="mt-4 space-y-2">
          {['PDF', 'Word', 'Markdown', 'Plain Text'].map((format) => (
            <label key={format} className="flex items-center gap-2">
              <input type="checkbox" className="text-indigo-600" />
              <span className="text-sm">{format}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="space-y-2">
        <Button className="w-full gap-2">
          <Download className="h-4 w-4" />
          Download All
        </Button>
      </div>
    </div>
  );
}